import React, { FC } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Modal, Text, Button } from '../../components';

interface RemoveNotesAndPhotosConfirmationModalProps {
    onApprove: () => void;
    onAbort: () => void;
}

const RemoveNotesAndPhotosConfirmationModal: FC<RemoveNotesAndPhotosConfirmationModalProps> = ({ onApprove, onAbort }) => {
  const { t } = useTranslation();

  return (
    <Modal open onClose={onAbort}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          alignItems: 'center',
        }}
      >
        <Text
          fontLevel="title"
          fontSize="large"
          sx={{ color: (theme) => theme.palette.neutral.variation40 }}
        >
          {t('cloud_dvir__all_notes_and_photos_will_be_removed')}
        </Text>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button isFilled size="small" onClick={onApprove}>
            {t('cloud_dvir__continue')}
          </Button>
          <Button isFilled viewType="secondary" size="small" onClick={onAbort}>
            {t('cloud_dvir__cancel')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RemoveNotesAndPhotosConfirmationModal;
